import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectHalcyonFormInclusionSchema = createSelector(
  getSystem,
  ({ halcyonFormInclusionSchema }) => halcyonFormInclusionSchema,
);
